<template>
  <a-modal
    v-model:open="show"
    destroy-on-close
    width="600px"
    :mask-closable="false"
    :afterClose="handleClose"
    v-bind="modalAttrs"
  >
    <template #title>
      <slot name="title" />
    </template>
    <slot>
      <component
        :is="component.default"
        ref="compRef"
        v-bind="attrs"
      />
    </slot>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch, computed, useAttrs } from 'vue'
import { useStore } from 'vuex'

interface DialogProps {
  component: any
  uid: string
}

const props = withDefaults(
  defineProps<DialogProps>(),
  {}
)

const store = useStore()
const show = ref(false)
const compRef = ref()
const curRef = computed(() => compRef.value)

const modal: any = ref(null)
const attrs: any = ref({})
const setState = (data: any) => {
  if (data[props.uid]) {
    // current传递给组件的参数
    const current = data[props.uid]
    attrs.value = current
    show.value = current.show
    if (current.modal) {
      // current.modal传递给dialog参数
      modal.value = current.modal
    }
  }
}

const modalAttrs = computed(() => {
  // modal的title取attrs的数据
  // tipModal取slot的数据（fix title优先级高于slot）
  if (modal.value) {
    const { title, ...rest } = modal.value
    return { ...useAttrs(), ...rest }
  }
  return useAttrs()
})

const handleClose = () => {
  if (props.uid) {
    store.commit('modal/close', { uid: props.uid })
  }
}

watch(
  () => store.state.modal.data,
  setState,
  { deep: true }
)

defineExpose({ curRef })
</script>
